import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccountInitialsPipe } from './account-initials/account-initials.pipe';
import { ColorFromNamePipe } from './color-from-name/color-from-name.pipe';
import { DatezPipe } from './datez/datez.pipe';
import { DatezSmsPipe } from './datez-sms/datez-sms.pipe';
import { DropdownSearchPipe } from './dropdown-search/dropdown-search.pipe';
import { FormatMaskedIdPipe } from './format-masked-id/format-masked-id.pipe';
import { HhmmssPipe } from './hhmmss/hhmmss.pipe';
import { ItemSelectedPipe } from './item-selected/item-selected.pipe';
import { NoNullNumberPipe } from './no-null-number/no-null-number.pipe';
import { OrderByPipe } from './order-by/order-by.pipe';
import { ReplaceCharTitleCasePipe } from './replace-char-title-case/replace-char-title-case.pipe';
import { SafeIFrameUrlPipe } from './safe-iframe-url/safe-iframe-url.pipe';
import { SentenceCasePipe } from './sentence-case/sentence-case.pipe';
import { TitleCasePipe } from './title-case/title-case.pipe';
import { ToSentencePipe } from './to-sentence/to-sentence.pipe';

@NgModule({
  declarations: [
    DatezPipe,
    DatezSmsPipe,
    DropdownSearchPipe,
    HhmmssPipe,
    ColorFromNamePipe,
    AccountInitialsPipe,
    FormatMaskedIdPipe,
    ItemSelectedPipe,
    TitleCasePipe,
    OrderByPipe,
    ReplaceCharTitleCasePipe,
    ToSentencePipe,
    SafeIFrameUrlPipe,
    NoNullNumberPipe,
    SentenceCasePipe,
  ],
  exports: [
    DatezPipe,
    DatezSmsPipe,
    DropdownSearchPipe,
    HhmmssPipe,
    ColorFromNamePipe,
    AccountInitialsPipe,
    FormatMaskedIdPipe,
    ItemSelectedPipe,
    TitleCasePipe,
    OrderByPipe,
    ReplaceCharTitleCasePipe,
    ToSentencePipe,
    SafeIFrameUrlPipe,
    NoNullNumberPipe,
    SentenceCasePipe,
  ],
  imports: [CommonModule],
})
export class PipesModule {}
